/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/compose_medium'
export default icon
